<!--
 * @Version      : V1.0
 * @Date         : 2025-03-25 15:16:56
 * @fileName     : 供应商信息
 * @Description  :
-->
<template>
  <div class="customerProfile-con px-20 py-20 border-box">
    <el-card class="box-card">
      <div class="query-con">
        <el-form :inline="true" :model="formInline" ref="ruleForm" class="demo-form-inline">
          <el-form-item label="供应商编号" porp="supplierCode">
            <el-input v-model="formInline.supplierCode" placeholder="供应商编号"></el-input>
          </el-form-item>
          <el-form-item label="供应商名称" porp="supplierName">
            <el-input v-model="formInline.supplierName" placeholder="供应商名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="queryData">查询</el-button>
            <el-button @click="resetData('ruleForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <div class="operate py-20 border-box">
      <el-button type="success" @click="addItem()">新增</el-button>
      <!-- <el-button type="primary">导出</el-button>
      <el-button type="primary">导入</el-button> -->
    </div>
    <div class="table-con">
      <tableComponent :columns="columns" :tableData="dataList" @preSizeChange="childSizeChange"
        @preCurrentChange="childCurrentChange" :loading="loading" :pagination="pagination">
        <template #operate="{ row }">
          <div>
            <el-button type="text" @click="details(row)">详情</el-button>
            <el-button type="text" @click="edit(row)">修改</el-button>
            <el-button type="text" @click="removeItem(row)" style="color:#F56C6C;">删除</el-button>
          </div>
        </template>
      </tableComponent>
    </div>
    <supplierInfoDetails ref="supplierInfoDetailsRefs" @initQueryData="queryData" :title="detailsT"
      :status="preStatus"></supplierInfoDetails>
  </div>
</template>

<script>
import supplierInfoDetails from './components/supplierInfoDetails.vue'
import tableComponent from '@/components/tableComponent/index.vue'
import { querySupplierInfoApi, querySupplierInfoDeteleApi } from '@/api/basicInfo/index'
export default {
  components: {
    tableComponent,
    supplierInfoDetails
  },
  data() {
    return {
      loading: false,
      detailsT: '供应商信息详情',
      formInline: {
        supplierName: "",
        supplierCode: "",
      },
      dataList: [],
      preStatus: '',
      columns: [
        {
          id: 0,
          title: "序号", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "68px",
          keyName: "i", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 1,
          title: "供应商编号", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "auto",
          keyName: "supplierCode", // 数据的属性值
          align: "left",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 2,
          title: "供应商名称", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "228px",
          keyName: "supplierName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 3,
          title: "联系人", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "128px",
          keyName: "supplierContactPerson", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 4,
          title: "联系电话", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "120px",
          keyName: "supplierContactPhone", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 5,
          title: "提交人", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "createByName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 6,
          title: "创建日期", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "220px",
          keyName: "createTime", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },

        {
          id: 9,
          title: "操作", // 标题名称
fixed:"right",
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "150px",
          keyName: "", // 数据的属性值
          align: "left",
          slotName: "operate", // 插槽名,为空字符串时不使用
        }
      ],
      pagination: {
        pageCount: 7, //总页数
        total: 0, //总条目数
        pageSize: 1,//当前页条数
        pageSizes: [10, 20, 100]
      }
    }
  },
  mounted() {
    this.queryData()
  },
  methods: {
    queryData() {
      this.initData()
    },
    initData(item = {}) {
      let params = {
        pageNum: "1",
        pageSize: "10",
        query: {
          params: {
            supplierCode: "",
            supplierName: "",
            ...this.formInline
          }
        },
        ...item
      }
      this.loading = true;
      querySupplierInfoApi(params).then(res => {
        this.loading = false;
        if (res.code == 200) {
          this.dataList = res.data.rows;
          this.pagination.total = res.data.total;
        }
      })
    },
    childSizeChange(page) {
      this.initData({ pageSize: page })
    },
    childCurrentChange(value) {
      this.initData({ pageNum: value })
    },
    resetData(formName) {
      this.formInline.supplierCode = "";
      this.formInline.supplierName = "";
      this.$nextTick(() => {
        this.initData()
      })
    },
    addItem() {
      this.preStatus = 'add'
      this.detailsT = '供应商信息新增'
      this.$refs.supplierInfoDetailsRefs.openDrawer({})
    },
    details(row) {
      this.preStatus = 'view'
      this.detailsT = '供应商信息详情'
      this.$refs.supplierInfoDetailsRefs.openDrawer(row)
    },
    edit(row) {
      this.preStatus = 'edit'
      this.detailsT = '供应商信息编辑'
      this.$refs.supplierInfoDetailsRefs.openDrawer(row)
    },
    removeItem(row) {
      this.$confirm('确定要删除该供应商？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.loading = true;
        querySupplierInfoDeteleApi({id:row.id}).then(res=>{
          if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: 'success'
              });
            } else {
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            }
             this.loading = false;
             this.initData()
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.customerProfile-con {
  background: #f7f4f4;

  .box-card {
    width: 100%;
  }

  .operate {}
}
</style>
